import styled from "styled-components";
export const Styles = styled.div`
  .main-container {
    display: "flex";
    flex-direction: "column";
    align-items: "center";
    gap: "50px";
    padding: 0;
    margin-top: "50px";
    border-radius: "26px";
  }
  .data-container {
    .main-details {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-bottom: 40px;
      .checkbox-container {
        display: flex;
        align-items: flex-start;
        padding-inline-start: 10px;
        padding-top: 5px;
        border: 1px solid rgba(0, 0, 0, 0.23);
      }
      .griddy-data {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        @media (max-width: 992px) {
          grid-template-columns: 1fr;
        }
      }
    }
    .contacts {
      .contacts-data-container {
        margin-top: 20px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }
    }
    .payment-contact {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .payment-input {
        display: flex;
        align-items: center;
        gap: 20px;
        .add-payment-method {
          color: black;
          padding: 4px 8px;
          border-radius: 5px;
          min-width: 40px;
          min-height: 40px;
          transition: 0.3s;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .methods {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .method {
          position: relative;
          display: flex;
          align-items: center;
          border-radius: 9px;
          padding: 10px 12px;
          font-size: 14px;
          .remove-method {
            padding: 1px;
            border-radius: 2px;
            position: absolute;
            top: -5px;
            right: -5px;
            background-color: white;
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }
    .MuiInputBase-input {
      padding-top: 15px !important;
      padding-bottom: 15px;
    }
  }
  .logo-container {
    margin-top: 30px;
    .switcher {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
    }
    .logo-ways-container {
      display: flex;
      flex-direction: row;
      gap: 40px;
      @media (max-width: 1200px) {
        align-items: center;
        flex-direction: column;
      }
      position: relative;
      justify-content: space-between;
      width: 100%;
      .custom-logo {
        display: flex;
        justify-content: center;
        border-radius: 5px;
        align-items: center;
        height: 300px;
        text-align: center;
        position: relative;
        border: #303030 solid 1px;
        .files {
          opacity: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .selected-logo-container {
          position: relative;
          width: 80%;
          height: 80%;
          border-radius: 5px;
          overflow: hidden;
          .selected-logo-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 5px;
          }
          .selected-logo-remove {
            position: absolute;
            top: 5px;
            right: 5px;
            color: white;
            background-color: red;
            border-radius: 5px;
            &:hover {
              opacity: 0.7;
            }
          }
        }
      }
      .logo {
        border: 1px solid #303030;
        border-radius: 5px;
        width: 100%;
        .main-title {
          margin-top: 20px;
          margin-bottom: -10px;
        }
        .main-logo-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          padding: 20px;
          .main-styles-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 60%;
            .title-container {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
          }
        }
        .styles-picker-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
        }
        .font-chooses-container {
          display: flex;
          flex-direction: row;
          width: 100%;
          gap: 10px;
          margin-top: 4px;
          justify-content: space-evenly;
          .font-style-container {
            background: #e5edff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 4px;
            border: 1px solid #959595;
            border-radius: 5px;
            padding: 4px;
            width: 100%;
            .font-style {
              font-size: 18px;
              line-height: 24px;
              font-weight: 600;
              color: #474747;
            }
          }
        }
        .colors-container {
          display: flex;
          flex-direction: column;
          gap: 6px;
          .color {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: color;
            cursor: pointer;
            border: 1px #303030 solid;
            transition: border 0.3s ease;
          }
        }
        .final {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          width: 35%;
          height: 200px;
          .final-logo-container {
            background: radial-gradient(circle, #51aafd, #002d68);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            padding: 40px;
            border-radius: 5px;
            width: 130px;
            height: 100px;
            overflow: hidden;
            .final-logo {
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  .submit-btn {
    margin-top: 30px;
    .MuiButton-root {
      width: 150px;
    }
  }
  
    //////////////////////////////////////////////////
  .slider-container {
    margin-top: 30px;
    .switcher {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
    }
    .slider-ways-container {
      display: flex;
      flex-direction: row;
      gap: 40px;
      @media (max-width: 1200px) {
        align-items: center;
        flex-direction: column;
      }
      position: relative;
      justify-content: space-between;
      width: 100%;
      .custom-slider {
        display: flex;
        justify-content: center;
        border-radius: 5px;
        align-items: center;
        height: 500px;
        text-align: center;
        position: relative;
        border: #303030 solid 1px;
        .files {
          opacity: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        
        
        
        .selected-slider-container {
        display:flex;
        flex-wrap: wrap; 
        justify-content: space-between;
          width: 80%;
          height: 80%;
          border-radius: 5px;
          overflow: hidden;
          
          
            .selected-image{
              position: relative;
              flex: 0 0 calc(50% - 8px);
              box-sizing: border-box;
              .selected-logo-img {
                object-fit: contain;
                border-radius: 5px;
              }
              .selected-image-remove {
                position: absolute;
                top: 5px;
                right: 5px;
                color: white;
                background-color: red;
                border-radius: 5px;
                &:hover {
                  opacity: 0.7;
                }
              }
            }
        }
      }
      .logo {
        border: 1px solid #303030;
        border-radius: 5px;
        width: 100%;
        .main-title {
          margin-top: 20px;
          margin-bottom: -10px;
        }
        .main-logo-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: start;
          height: 100%;
          padding: 20px;
          .main-styles-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 80%;
            .title-container {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
          }
        }
        .styles-picker-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
        }
        .font-chooses-container {
          display: flex;
          flex-direction: row;
          width: 100%;
          gap: 10px;
          margin-top: 4px;
          justify-content: space-evenly;
          .font-style-container {
            background: #e5edff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 4px;
            border: 1px solid #959595;
            border-radius: 5px;
            padding: 4px;
            width: 100%;
            .font-style {
              font-size: 18px;
              line-height: 24px;
              font-weight: 600;
              color: #474747;
            }
          }
        }
        .colors-container {
          display: flex;
          flex-direction: column;
          gap: 6px;
          .color {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: color;
            cursor: pointer;
            border: 1px #303030 solid;
            transition: border 0.3s ease;
          }
        }
        .final {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          width: 35%;
          height: 200px;
          .final-logo-container {
            background: radial-gradient(circle, #51aafd, #002d68);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            padding: 40px;
            border-radius: 5px;
            width: 130px;
            height: 100px;
            overflow: hidden;
            .final-logo {
              font-weight: 700;
            }
          }
        }
      }
    }
  }
`;
